module.exports = __webpack_public_path__ + "static/img/chain-id.f546b5c7.png";